import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMerged: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMerged"><Path d="M6 3C7.39761 3 8.56905 3.95647 8.90234 5.25H18.75V15.0977C20.0435 15.431 21 16.6024 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6024 15.9565 15.431 17.25 15.0977V6.75H8.90234C8.63089 7.80351 7.80348 8.62983 6.75 8.90137V15.0977C8.04354 15.431 9 16.6024 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6024 3.95647 15.431 5.25 15.0977V8.90137C3.95658 8.56799 3 7.39752 3 6C3 4.34315 4.34315 3 6 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMerged;
